import moment from 'moment';
import { convertEnumToStringArray } from './enumHelpers';
import { NotPresentError } from './LocalCache';
import { sentryConfigGenerator } from './sentryConfig';
export * from './FeathersUtils';
export * from './FileUtils';
export * from './ProtocolTypeUtils';
export * from './SchemaUtils';
export * from './SigningUtils';
export * from './VersioningUtils';
const getUtcNow = () => moment().utc().toISOString();
export { convertEnumToStringArray, getUtcNow, NotPresentError, sentryConfigGenerator };
//# sourceMappingURL=index.js.map